import React from 'react'
import { TitleSizeEnum } from '@/__gen/types'
import { useFormContext } from '@/state/main-form/reducer'
import { MainFormAuthQuery } from '@/state/main-form/get-main-form-auth/__gen'
import { InfoBlock } from '../info-block'
import { useLlmResponseHtmlPoll } from './useLlmResponseHtmlPoll'

type Props = {
	llmInterface: ReturnType<typeof useFormContext>['form']['llmInterface']
	index: number
}

export const LlmResponseHtml = ({ index, llmInterface }: Props) => {
	const formContext = useFormContext()
	const polledHtml = useLlmResponseHtmlPoll(formContext.form.id, formContext.record.id)

	return <InfoBlock
		isFirst={index == 0}
		title=""
		titleSize={TitleSizeEnum.Medium}
		contentHtml={polledHtml ?? ''}
		hasPaddingBefore={true}
		hasPaddingAfter={true}
		recordId={formContext.record.id}
		metabaseDashboards={[]}
	/>
}
